import React, {
    useState,
    useEffect,
    useCallback,
    useRef,
    useMemo,
} from "react";
import PropTypes from "prop-types";
import { validatePONumber } from "../../helpers/InputValidationHelper";

export default function PONumber(props) {
    const { isRequired, localized, poNumberUpdated, maxLength, poNumber, forceValidate } = props;

    const [inputValue, setInputValue] = useState(poNumber || "");
    const [error, setError] = useState("");
    const [touched, setTouched] = useState(false);
    const debounceTimerRef = useRef(null);

    const remainingChars = useMemo(
        () => (inputValue ? Math.max(0, maxLength - inputValue.length) : maxLength),
        [inputValue, maxLength]
    );

    const handleChange = (e) => {
        const raw = e.target.value ?? "";
        const next = raw.length > maxLength ? raw.slice(0, maxLength) : raw;

        setInputValue((prev) => (prev === next ? prev : next));

        if (error) {
            setError("");
        }
        poNumberUpdated?.(next);
    };

    const handleBlur = () => {
        setTouched(true);

        const { isValid, error: validationError } = validatePONumber(
            isRequired,
            inputValue,
            localized,
            maxLength
        );

        setError(isValid ? "" : validationError);
    };

    useEffect(() => {
        const next = poNumber ?? "";
        setInputValue((prev) => (prev === next ? prev : next));
    }, [poNumber]);

    useEffect(() => {
        if (forceValidate) {
            setTouched(true);

            const { isValid, error: validationError } = validatePONumber(
                isRequired,
                inputValue,
                localized,
                maxLength
            );

            setError(isValid ? "" : validationError);
            return;
        }

        if (touched || inputValue) {
            const { isValid, error: validationError } = validatePONumber(
                isRequired,
                inputValue,
                localized,
                maxLength
            );
            setError(isValid ? "" : validationError);
        } else {
            setError("");
        }
    }, [forceValidate, touched, inputValue, isRequired, localized, maxLength]);

    useEffect(() => {
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);

    return (
        <div className="fele-cart-po-number">
            <div className="fele-content">
                <div className="input-wrapper">
                    <input
                        name="poNumber"
                        type="text"
                        value={inputValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required={isRequired}
                        maxLength={maxLength}
                        className={error ? "error" : ""}
                    />

                    <div className="textarea-note">
                        {`${remainingChars} ${localized.CharactersLeft}`}
                    </div>

                    {error ? (
                        <div style={{ color: "red", fontSize: "1.4rem", marginTop: "4px" }}>
                            {error}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

PONumber.propTypes = {
    isRequired: PropTypes.bool,
    poNumberUpdated: PropTypes.func,
    poNumber: PropTypes.string,
    maxLength: PropTypes.number,
    localized: PropTypes.object,

    forceValidate: PropTypes.bool,
};

PONumber.defaultProps = {
    forceValidate: false,
};

